import * as React from 'react';
import clsx from 'clsx';

import { AccordionButton } from '../Button';

interface Props {
  label: string;
  classNames?: { readonly [key: string]: string };
  children: React.ReactNode;
  isOpenDefault?: boolean;
  isOpen?: boolean;
  onRequestOpenClose?: (isOpen: boolean) => void;
  isSmall?: boolean;
  isDisabled?: boolean;
  isSecondary?: boolean;
  style?: React.CSSProperties;
  after?: React.ReactNode;
  sibling?: React.ReactNode;
}

// new-ui
export function Accordion({
  children,
  isOpenDefault = true,
  isOpen: isOpenProp,
  onRequestOpenClose,
  isDisabled,
  after,
  sibling,
  classNames = {},
  style,
  ...rest
}: Props) {
  if (typeof isOpenProp !== 'undefined' && !onRequestOpenClose) {
    throw new Error('Accordion: isOpen prop be defined together with onRequestOpenClose prop');
  }

  const [isOpenState, setIsOpenState] = React.useState(isOpenDefault);

  const isOpen = typeof isOpenProp !== 'undefined' ? isOpenProp : isOpenState;

  React.useEffect(() => {
    if (isDisabled && isOpen) {
      setIsOpenState(false);

      if (onRequestOpenClose) onRequestOpenClose(!isOpen);
    }
  }, [isDisabled, isOpen, onRequestOpenClose]);

  function clickHandler() {
    if (!isDisabled) {
      setIsOpenState(!isOpen);

      if (onRequestOpenClose) {
        onRequestOpenClose(!isOpen);
      }
    }
  }

  return (
    <>
      <div className={clsx(classNames.container, { [classNames.open]: isOpen }, 'row a-center')} style={style}>
        <span className={clsx(classNames.sibling, { ['row a-center']: sibling })}>
          <AccordionButton
            className={classNames.button}
            onClick={clickHandler}
            isOpen={isOpen}
            isDisabled={isDisabled}
            {...rest}
          />
          {sibling}
        </span>
        {after}
      </div>
      {isOpen && children}
    </>
  );
}
